<style src='style.scss'>

</style>

<article class="mbsc-col-12 player-demo">
  <header>
    <h1>Nuestro reproductor de videos</h1>
    <p>Solo D-NS Studio te brinda el mejor reproductor de video para que saques el 100% de cada sesión.</p>
  </header>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6">
      <ul class="mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/speed-limit.png" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">Velocidad de Reproducción</h5>
                <div class="mbsc-card-subtitle">Reduce la velocidad de reproducción del video para que no pierdas detalle de cada movimiento.</div>
            </div>
        </li>
      </ul>
    </div>
    <div class="mbsc-col-12 mbsc-col-md-6">
      <img class="mbsc-media-fluid" src="/images/play-rate-video.jpg" alt="play-rate">
    </div>
  </div>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6">
      <img class="mbsc-media-fluid" src="/images/loop-video.jpg" alt="loop-video">
    </div>
    <div class="mbsc-col-12 mbsc-col-md-6">
      <ul class="mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/loop.png" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">Modo Repetición</h5>
                <div class="mbsc-card-subtitle">Cuando necesites perfeccionar un movimiento, activa el modo Loop, y ¡dominalo!.</div>
            </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6">
      <ul class="mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/mirror.png" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">Modo Espejo</h5>
                <div class="mbsc-card-subtitle">Si te resulta dificil escuchar un lado y ver al instructor moverse en el sentido contrario, ¿por qué no pruebas el modo espejo?.</div>
            </div>
        </li>
      </ul>
    </div>
    <div class="mbsc-col-12 mbsc-col-md-6">
      <img class="mbsc-media-fluid" src="/images/mirror-video.jpg" alt="mirror-video">
    </div>
  </div>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6">
      <img class="mbsc-media-fluid" src="/images/camera-video.jpg" alt="toogle">
    </div>
    <div class="mbsc-col-12 mbsc-col-md-6">
      <ul class="mbsc-col-12 mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/toggle.png" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">Videos a doble cámara</h5>
                <div class="mbsc-card-subtitle">Los instructores de D-NS Studio graban sus sesiones a doble cámara, para que ningún detalle pase por alto.</div>
            </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6">
      <ul class="mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/hashtag.png" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">#challenge mode</h5>
                <div class="mbsc-card-subtitle">Grabate haciendo las coreografías de D-NS Studio y muestranos tu progreso.</div>
            </div>
        </li>
      </ul>
    </div>
    <div class="mbsc-col-12 mbsc-col-md-6">
      <img class="mbsc-media-fluid" src="/images/challenge-video.jpg" alt="challenge-mode">
    </div>
  </div>
  <div class="mbsc-row">
    <div class="mbsc-col-12 mbsc-col-md-6 mbsc-align-center">
      <h1>¡Prueba nuestro reproductor y llévalo contigo a donde sea!</h1>
      <PlayerCore></PlayerCore>
    </div>
    <div class="mbsc-col-md-6">
      <ul class="mbsc-col-12 mbsc-card-list">
        <li>
            <div class="mbsc-card-content">
                <img src="/images/logo-d-ns-studio.png" width="150px" height="auto" draggable="false" class="mbsc-avatar" alt="video-step">
                <h5 class="mbsc-card-title mbsc-bold">¡Regístrate hoy!</h5>
                <div class="mbsc-card-subtitle">Registrate a D-NS Studio hoy y tendrás 7 días gratis de acceso ilimitado a todas nuestras clases.</div>
                <button class="mbsc-button mbsc-btn-primary" on:click={redirectTo}>Regístrarse</button>
            </div>
        </li>
      </ul>
    </div>
  </div>
</article>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  import PlayerCore from '@Components/PlayerCore/index.svelte';
  import { Navigation, AWSAuth } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let member = null;
  
  const dispatch = createEventDispatcher();

  let redirectTo = () => {
    if (typeof member === 'string') {
      Navigation.goTo('signup');
    }else{
      Navigation.goTo('account');
    }
  };

  afterUpdate(() => {
    mobiscroll.card('ul.mbsc-card-list>li', {});
    member = AWSAuth.getUser();
  });

  onMount(async () =>{});

</script>
